import React from "react";
import Box from "@mui/material/Box";
import { Controller } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import "../styles.css";

const FormSelect = ({
  name,
  control,
  label,
  options,
  onChange,
  defaultValue,
  width,
  formLabel,
  error,
  disabled = false,
  margin
}) => {
  const StyledAutocomplete = styled(Autocomplete)(() => ({
    width: width ? width : "auto",
    margin: margin ? margin : "5px",
    "& .MuiInputBase-root": {
      height: "40px",
      borderRadius: "6px"
    }
  }));

  return (
    <Box sx={{ minWidth: 120 }}>
      <p className="select-form-label">{label}</p>
      <FormControl fullWidth error={Boolean(error)}>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue || null}
          render={({ field }) => (
            <StyledAutocomplete
              {...field}
              disabled={disabled}
              options={options}
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) => 
                option.value === value?.value || option.value === value
              }
              value={
                options.find((opt) => opt.value === field.value) || null
              }
              onChange={(event, newValue) => {
                const selectedValue = newValue ? newValue.value : null;
                field.onChange(selectedValue);
                onChange && onChange(selectedValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={formLabel}
                  variant="outlined"
                  error={Boolean(error)}
                />
              )}
              noOptionsText="No hay opciones"
              clearText="Limpiar"
              openText="Abrir"
              closeText="Cerrar"
            />
          )}
        />
        {error && <p className="error-message">{error.message}</p>}
      </FormControl>
    </Box>
  );
};

export default FormSelect;
